module.exports = __webpack_public_path__ + "media/images/icons/cart-c5c8ae49cda614f3518e1c3cdb8fd856.svg";